const createType = (perfix: string) => {
  return {
    REQUEST: perfix + '_REQUEST',
    SUCCESS: perfix + '_SUCCESS',
    FAILED: perfix + '_FAILED'
  };
};

// export const SEARCH_CUSTOMER_NAME = createType('SEARCH_CUSTOMER_NAME');
export const COURSE_TYPES = createType('COURSE_TYPES');
export const COURSE_CATEGORY = createType('COURSE_CATEGORY');
export const COURSE_INFO = createType('COURSE_INFO');
export const COURSE_SCORE = createType('COURSE_SCORE');
export const COURSE_SCORE_SET = createType('COURSE_SCORE_SET');
export const COURSE_PLAYED = createType('COURSE_PLAYED');
export const COURSE_FEEDBACK = createType('COURSE_FEEDBACK');
